import { render } from "./ReleaseQueue.vue?vue&type=template&id=6c37c11b&lang=html"
import script from "./ReleaseQueue.vue?vue&type=script&lang=js"
export * from "./ReleaseQueue.vue?vue&type=script&lang=js"

import "./ReleaseQueue.vue?vue&type=style&index=0&id=6c37c11b&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__